import { storage_keys } from '@/constant/configs';
import {
  setRestaurantTokenToCookie,
  removeRestaurantToken,
} from '@/lib/actions/restaurant';
import { restaurant } from '@/lib/utils/routeLinks';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { logOut } from '@/clients/restaurant/auth';
import toast from 'react-hot-toast';
import { UserType } from '@/lib/types/restaurant/User';
import {
  removeRestaurantAuthCreds,
  removeRestaurantImpersonateIDs,
} from '@/lib/utils/functions';
interface AuthResponse {
  data: {
    token: string;
    refresh_token: string;
    user: UserType;
    token_expires_at: string;
  };
}

type SetUserFunction = (token: string) => void;
type removeUserFunc = () => void;

export default function useRestaurantAuth() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleRestaurantLogin = async (
    res: AuthResponse,
    setUser: SetUserFunction
  ) => {
    localStorage.removeItem(storage_keys.customer_cart);
    // Remove impersonate id if available
    localStorage.removeItem(storage_keys.res_impersonate_id);
    localStorage.setItem(storage_keys.restaurant_token, res.data.token);
    localStorage.setItem(
      storage_keys.restaurant_refresh_token,
      res.data.refresh_token
    );

    await setRestaurantTokenToCookie(res.data.token, res.data.token_expires_at);
    await setUser(res.data.token);

    const redirectUrl =
      searchParams.get('redirect') || restaurant.dashboard.de();
    router.push(redirectUrl);
  };

  const handleRestaurantLogout = (
    removeUser: removeUserFunc,
    impersonateId: string | boolean
  ) => {
    if (!impersonateId) {
      logOut()
        .then(() => {
          removeRestaurantAuth(removeUser);
        })
        .catch((err) => {
          toast.error(err?.response?.message);
        });
    } else {
      removeRestaurantAuth(removeUser);
    }
  };

  const removeRestaurantAuth = (
    removeUser: removeUserFunc,
    redirect = true
  ) => {
    removeRestaurantAuthCreds();
    // Remove impersonate id if available
    removeRestaurantImpersonateIDs();
    removeUser();
    removeRestaurantToken();

    if (redirect) {
      window.location.href = restaurant.login.de();
    }
  };

  const checkRestaurantAuthAndRedirect = () => {
    const token = localStorage.getItem(storage_keys.restaurant_token);
    if (token) {
      router.push(restaurant.dashboard.de());
    }
  };

  return {
    handleRestaurantLogin,
    checkRestaurantAuthAndRedirect,
    handleRestaurantLogout,
    removeRestaurantAuth,
  };
}
